// extracted by mini-css-extract-plugin
export var ExitModal = "ExitModal-module--ExitModal--2_RXz";
export var ExitModal__content = "ExitModal-module--ExitModal__content--12Yeg";
export var ExitModal__title = "ExitModal-module--ExitModal__title--aIg2D";
export var ExitModal__body = "ExitModal-module--ExitModal__body--3UXJB";
export var ExitModal__buttongroup = "ExitModal-module--ExitModal__buttongroup--3EMiu";
export var ExitModal__button = "ExitModal-module--ExitModal__button--26_vP";